import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import DataCell from "@/components/DataCell";
import { getOrderDetails } from "@/utils/order";
import { Flow, Order, OrderItem } from "@/types";
import { useAppSelector } from "@/hooks";
import { es } from "date-fns/locale";
import { MENU_FLOW_LABELS } from "@/constants/global";
import { getFirstAndLastName } from "@/utils/names";

interface Props {
  order: Order;
}

const ReceiptKitchenTemplate = ({ order }: Props) => {
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const currentOrganization = useAppSelector((store) => store.organizations[organizationId] ?? null);

  return (
    <Stack className="receipt-template" padding={3} spacing={2} bgcolor="white" width="100%">
      <Stack alignItems="center">
        <Typography variant="h2" fontWeight={700} fontSize={'16px'}>
          {currentOrganization?.title}
        </Typography>

        <Typography variant="h3" fontSize={'14px'}>Cocina [ {MENU_FLOW_LABELS[order?.flow as keyof typeof MENU_FLOW_LABELS]} ]</Typography>
      </Stack>

      <Stack>
        {order?.branch ? <DataCell label="Sucursal" value={order?.branch?.title as unknown as string} fontSize={'14px'} /> : null}
        <DataCell label="Orden" value={order?.number as unknown as string} fontSize={'14px'} />
        <DataCell label="Cliente" value={getFirstAndLastName(order?.client?.name + " " + order?.client?.lastname)} fontSize={'14px'} />
        <DataCell label="Tipo" value={order?.flow as unknown as string} fontSize={'14px'} />
        <DataCell label="Hora" value={order?.archivedAt ? format(order.archivedAt, "p") : order?.lastUpdatedAt ? format(order.lastUpdatedAt, "p") : "N/A"} fontSize={'14px'} />
        <DataCell label="Fecha" value={order?.archivedAt ? format(order.archivedAt, "dd/MM/yyyy") : order?.lastUpdatedAt ? format(order.lastUpdatedAt, "dd/MM/yyyy") : "N/A"} fontSize={'14px'} />
        {(order?.flow as string) === Flow.PICKUP ? (
          <DataCell label="Hora de recogida" value={order?.scheduleTime ? format(order.scheduleTime.toDate(), " hh:mm a", { locale: es }) : "N/A"} sx={{ fontSize: '14px' }} />
        ) : null}
      </Stack>

      <Stack direction="row" justifyContent="space-between" borderTop={2} borderBottom={2}>
        <Typography variant="caption" fontWeight="bold" fontSize={'14px'}>
          ITEMS
        </Typography>
      </Stack>
      {order?.items?.map((item: OrderItem) => (
        <Stack key={item.id} spacing={2}>
          <Stack direction={"row"} spacing={2} justifyContent="space-between">
            <Stack spacing={2} direction={"row"}>
              <Typography flex={1} fontSize={'14px'}>{item.quantity}</Typography>
              <div>
                <Typography flex={1} fontWeight="bold" fontSize={'14px'}>
                  {item.title}
                </Typography>
                <Typography fontSize={'14px'}>{getOrderDetails(item)}</Typography>
              </div>
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default ReceiptKitchenTemplate;
